import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useIugu from '../../iugu';

import toastr from 'toastr';

import './styles.css';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import TituloPagina from '../Includes/Titulos';
import api from '../../services/api';
import { useTranslation } from 'react-i18next';


export default function PagamentoCartao() {
    const history = useHistory();
    const BASE_URL = 'https://agrobrazilapp.com/';
    const USER_EMAIL = sessionStorage.getItem('email');
    const USER_TOKEN = sessionStorage.getItem('token');
    const paymentForm = JSON.parse(sessionStorage.getItem('paymentForm'));
    const selectedPlan = JSON.parse(sessionStorage.getItem('selectedPlan'));
    const user_id =sessionStorage.getItem('id');
    const[tempToken, setTempToken]=useState();
    const [isSuccess,setIsSuccess]=useState();
    const [pdfpayment,setPdfpayment] =useState();
    const address=JSON.parse(sessionStorage.getItem('address'));
    const { t } = useTranslation();
    //AccountID ="86C5C83745B04C7DB074888085A52D16";
    var FormData = require('form-data');
    var data = new FormData();
    data.append('USER_TOKEN', USER_TOKEN);
    data.append('USER_EMAIL', USER_EMAIL);
   //toastr options
    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
      }
      
   function ImprimeBoleto(){
      return window.open(pdfpayment,"_blank");
   }
   
      

 class BoletoPayForm extends React.Component{
     render(){
         
        //envio de dados  pra autorizar o pagamento Boleto
        var axios = require('axios');
        var data = JSON.stringify({
          "subscription": {
                "card_token":"",
                "iugu_plan_identifier": selectedPlan.identifier,
                "payment_method":"bank_slip",
                "zip_code": address[2],
                "address_number": address[3],
                "user_id": user_id,
                "token": tempToken,
                "address": {
                  "state": address[0],
                  "city_id": address[1],
                  "zip_code": address[2],
                  "address_number": address[3]
                }
          }
        });
        var config = {
            method: 'post',
            url: `${BASE_URL}/v4/users/me/subscriptions`,
            headers: { 
              'USER_TOKEN': USER_TOKEN, 
              'USER_EMAIL': USER_EMAIL, 
              'Content-Type': 'application/json', 
            },
            data : data
          };
          
         axios(config)
          .then(function (response) {
            const {success, pdf} =response.data.response;
            console.log(response.data.response);
           
            setIsSuccess(success);
            setPdfpayment(pdf)
            
          })
          .catch(function (error) {
            console.log(error);
          });
            
         return(
            <form id="payment-form" onSubmit={handleSuccess}>
             
                <div>
                    <button class="btn-address" onClick={ImprimeBoleto} type="submit"> { t('pages.paymentTicket.buttons.printTicket') } </button>
                </div>

            </form>
         );
     };
   
 }

    function handleSuccess(){
        
     if(isSuccess===true){
            toastr.success(t('pages.paymentTicket.alerts.success'));
        }else{
            toastr.error(t('pages.paymentTicket.alerts.fail'));
        }          
        }
  
    useEffect(() => {
       //temporaryToken to payment
            var config = {
              method: 'post',
              url: `${BASE_URL}/v4/users/me/temporary_token`,
              headers: { 
                'USER_TOKEN': USER_TOKEN, 
                'USER_EMAIL': USER_EMAIL, 
              
              },
            };
            var axios =require('axios');
            axios(config)
            .then(function (response) {
              setTempToken(JSON.stringify(response.data.token));
            
            })
            .catch(function (error) {
              console.log(error);
            });
  
    //puxa historico dos dados pra autenticar os dados da pagina 
        api.get(`${BASE_URL}`, {
            headers: {
                'USER_EMAIL': USER_EMAIL,
                'USER_TOKEN': USER_TOKEN,
            }
        }).then(response => {

        }).catch(err => {
            if (err.status === 401) {
                history.push('/');
            }
        });
      

    }, [USER_EMAIL, USER_TOKEN, history]);
    
   
    return (
        <div >
            <div class="address-container">
            <Header />

           <TituloPagina titulo={ t('pages.paymentTicket.title') } />
            <div class="body-address">

            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/toastr.min.css" />
                <div class="all-inputs-center">
                <h2> { t('pages.paymentTicket.subtitle') } </h2>
                <h3 class="text-config">{selectedPlan.name} - {selectedPlan.price}</h3>

                    <BoletoPayForm />
                </div>
            </div>
            
            <Footer />
            </div>
        </div>
    );
}
